export const isMobileBrowser = /iPhone|iPad|iPod|Android/i.test(
  navigator.userAgent
);
